import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SearchIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 17.06 17.06"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 17.06)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
    >
      <circle cx="6.66" cy="6.66" stroke="none" r="6.66" />
      <circle cx="6.66" cy="6.66" r="5.91" />
      <path strokeLinecap="round" d="M12.96 12.96 16 16" />
    </SVG>
  );
};
